module.exports = __webpack_public_path__ + "img/contract-value-budget.c65df918.svg";